<template>
  <div class="survey-view-general">
    <dl class="dl-horizontal" v-if="hasEvent">
      <dt>Evento</dt>
      <dd>{{ survey.event && survey.event.name ? survey.event.name : '-' }}</dd>

      <dt>Pesquisador</dt>
      <dd>{{ survey.user && survey.user.name ? survey.user.name : '-' }}</dd>

      <dt>Duração da pesquisa</dt>
      <dd>{{ survey.duration ? survey.duration : '-' }}</dd>

      <dt>GPS</dt>
      <dd>{{ survey.gps && survey.gps.latitude ? survey.gps.latitude : '-' }}, {{ survey.gps && survey.gps.longitude ? survey.gps.longitude : '-' }}</dd>

      <dt>Alerta</dt>
      <dd>{{ survey.alert && survey.alert.toString() === "true" ? 'Sim' : 'Não' }}</dd>

      <dt>Observação</dt>
      <dd>{{ survey.observation ? survey.observation : '-' }}</dd>

      <dt>Aceitou participar?</dt>
      <dd>{{ survey.data && survey.data.accepted && survey.data.accepted.toString() === 'true' ? 'Sim' : 'Não' }}</dd>

      <dt v-if="survey.data && survey.data.accepted && survey.data.accepted.toString() === 'false'"> Motivo não participar </dt>
      <dd v-if="survey.data && survey.data.accepted && survey.data.accepted.toString() === 'false'">{{ survey.data.reasonNotAccepted ? survey.data.reasonNotAccepted : '-' }}</dd>

      <dt>Ausente?</dt>
      <dd> {{ survey.data && survey.data.absent && survey.data.absent.toString() === 'true' ? 'Sim' : 'Não' }} </dd>

      <dt v-if="survey.data && survey.data.absent && survey.data.absent.toString() === 'false'"> Motivo ausente </dt>
      <dd v-if="survey.data && survey.data.absent && survey.data.absent.toString() === 'false'"> {{ survey.data.reasonNotPresent ? survey.data.reasonNotPresent : '-' }} </dd>
    </dl>
  </div>
</template>
<script>
export default {
  name: 'survey-view-general',

  props: ['survey'],

  computed: {
    hasEvent () {
      return this.survey.hasOwnProperty('event')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyViewGeneral.vue